module.exports = "<div class=\"second-navbar-wrap\">\n  <logo></logo>\n  <app-menu></app-menu>\n</div>\n\n<div class=\"sidebar-overlay\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/ui/second-navbar/second-navbar.component.html
// module id = ../../../../../src/app/ui/second-navbar/second-navbar.component.html
// module chunks = 39